import type { FlatContentLayersType } from "@config";
import { getWholeEntityLayers } from "./getWholeEntityLayers";

export const copyEntityToClipboard = (
  id: string,
  flatContentLayers: FlatContentLayersType,
  cut = false,
) => {
  const entity = flatContentLayers[id];
  if (!entity) return;
  const payload = getWholeEntityLayers(entity.id, flatContentLayers);
  const comboName = getComboName({
    id: entity.id,
    entities: flatContentLayers,
  });
  if (cut) removeChildFromParent(entity.id, entity.parentId, flatContentLayers);
  const clipboard = JSON.stringify({
    entityEntryRootId: payload?.root,
    entities: payload?.entities,
    feature: "shortcut",
    comboName,
  });
  navigator.clipboard.writeText(clipboard);
};

const removeChildFromParent = (
  childId: string,
  parentId: string | null,
  flatContentLayers: FlatContentLayersType,
) => {
  const parent = flatContentLayers[parentId || ""];
  if (!parent) return;
  parent.childIds = parent.childIds.filter((id) => id !== childId);
  delete flatContentLayers[childId];
};

const getComboName = ({
  id,
  entities,
}: {
  id: string;
  entities: FlatContentLayersType;
}) => {
  const entity = entities[id];
  let currentEntity = entity;
  if (currentEntity.type === "slide") return undefined;
  while (currentEntity && currentEntity.type !== "combo") {
    currentEntity = entities[currentEntity.parentId as string];
  }
  return currentEntity ? currentEntity.settings.name : undefined;
};
